import { usePromptGroups } from './usePromptGroups';
import { useSelector } from 'react-redux';
import { selectPromptGroups } from '../../../reducers/promptLibraryReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';

const useInitializePromptGroups = () => {
  const { loadPromptGroups } = usePromptGroups();
  const promptGroups = useSelector(selectPromptGroups);

  useRunOnceWhenTruthy(() => {
    loadPromptGroups();
  }, !promptGroups);
};
export default useInitializePromptGroups;
